<template>
  <b-button
    id="luckyDraw-button"
    class="outline-button"
    :class="[isDisabled ? 'disabled-add' : '', customClass ? customClass : '']"
    :disabled="isDisabled"
  >
    <div class="d-flex align-items-center justify-content-center">
      <add-icon v-if="isShowIconAdd" class="fill-icon-lucky" />
      <download-icon v-if="isShowIconDown" class="fill-icon-lucky" />
      <!-- icon download -->
      <span class="ml-2" v-if="btnLabel">{{ btnLabel }}</span>
    </div>
  </b-button>
</template>

<script>
import { BButton } from "bootstrap-vue";
import AddIcon from "@/@core/components/svg/common/IconPlus.vue";
import DownloadIcon from "@/@core/components/svg/common/IconDownloadWinner.vue";

export default {
  components: {
    BButton,
    AddIcon,
    DownloadIcon,
  },
  props: {
    btnLabel: { type: String },
    isDisabled: { type: Boolean, default: false },
    isShowIconAdd: { type: Boolean, default: false },
    isShowIconDown: { type: Boolean, default: false },
    customClass: { type: String },
    imgSrc: { type: String },
  },
  setup() {
    return {};
  },
};
</script>

<style scoped>
#luckyDraw-button.outline-button {
  padding: 0.5rem 0.8rem;
  border-radius: 0.8rem;
  font-size: 22px;
}

#luckyDraw-button.outline-button svg {
  width: 14px;
  fill: var(--button-primary-font);
}

#luckyDraw-button .disabled-add svg {
  fill: #fff;
}

#luckyDraw-button.outline-button {
  border: 1px solid rgba(0, 127, 240, 1) !important;
  color: #007fff !important;
  background: #ffffff !important;
}

#luckyDraw-button.outline-button:hover {
  border: 1px solid rgba(0, 127, 240, 1) !important;
  background: #007fff !important;
  color: #ffffff !important;
}

#luckyDraw-button.outline-button .fill-icon-lucky {
  fill: #007fff !important;
}

#luckyDraw-button.outline-button:hover .fill-icon-lucky {
  fill: #ffffff !important;
}

#luckyDraw-button.outline-button.disabled-add {
  background-color: #e3e3e3 !important;
  border-color: #e3e3e3 !important;
  color: #fff !important;
  opacity: unset !important;
}
</style>
